module.exports = __webpack_public_path__ + "static/media/aboutus2.933a60b6.svg";